import Headings from "../../src/utils/csvHeadings.utils";
import { CommonCsvFunctions } from "./commonCsvFunctions.mixin";
import CommonService from "../../src/services/commonService";
import { resolve } from "url";

export const SetupUserAccounts = {
	mixins: [CommonCsvFunctions],
	data() {
		return {
			cities: [],
			regionsMapping: {}
		};
	},
	created() {
		// this.getCities();
	},
	methods: {
		getCities() {
			return CommonService.getCities("name")
				.then(response => {
					// console.log("cities", JSON.parse(response.data).results);
					return JSON.parse(response.data).results;
					// results.forEach(element => {
					// 	this.cities.push(element.name);
					// });
				})
				.catch(error => {
					console.log(error);
				});
		},
		processSetupUserAccounts(chunk) {
			if (!chunk.errors.length) {
				const headings = chunk.meta.fields;
				const status = this.checkHeadingsEquality(
					Headings.setupUserAccounts,
					headings
				);
				if (!status) {
					console.log(
						"Actual",
						Headings.setupUserAccounts,
						"headings from csv",
						headings
					);
					this.addError({
						row: 1,
						column: "Headings",
						details: `Headings required: ${Headings.setupUserAccounts}`
					});
				}
				if (status) {
					console.log("headings correct");
					const data = chunk.data;
					data.map((row, rowIndex) => {
						if (row.hasOwnProperty("Country")) {
							const value = row["Country"];
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "Country",
									details: "value is mandatory"
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Country",
									details: `value should be a string`
								});
							}
						}
						if (row.hasOwnProperty("City")) {
							const value = row["City"];
							if (value) {
								if (this.cities.indexOf(value) < 0) {
									this.addError({
										row: rowIndex + 2,
										column: "City",
										details: `value should be one of ${this.cities}`
									});
								}
							}
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "City",
									details: `value is mandatory`
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "City",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("Region")) {
							const region = row["Region"];
							const subregion = row["Sub Region/Zone"];
							console.log("region", region);
							if (rm.hasOwnProperty(region) && Boolean(subregion)) {
								rm[region].isSubRegion = true;
							} else if (!rm.hasOwnProperty(region) && Boolean(subregion)) {
								rm[region] = {
									isSubRegion: true
								};
							} else if (!rm.hasOwnProperty(region) && !Boolean(subregion)) {
								rm[region] = {
									isSubRegion: false
								};
							}

							if (!region && subregion) {
								this.addError({
									row: rowIndex + 2,
									column: "Region",
									details: `region is mandatory if subregion is given`
								});
							}
							if (region && !this.checkForString(region)) {
								this.addError({
									row: rowIndex + 2,
									column: "Region",
									details: `value should be a string`
								});
							}
						}
						if (row.hasOwnProperty("Sub Region/Zone")) {
							const subregion = row["Sub Region/Zone"];
							const region = row["Region"];
							if (
								rm.hasOwnProperty(region) &&
								rm[region].isSubRegion &&
								!subregion
							) {
								this.addError({
									row: rowIndex + 2,
									column: "Sub Region/Zone",
									details: `if a given region has subregion then all subregions under that region should have a value or not have value`
								});
							}
							if (subregion && !this.checkForString(subregion)) {
								this.addError({
									row: rowIndex + 2,
									column: "Sub Region/Zone",
									details: `value should be a string`
								});
							}
						}
						// console.log("regionsmapping", rm);
						if (row.hasOwnProperty("Store/Account Name")) {
							const value = row["Store/Account Name"];
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "City",
									details: `value is mandatory`
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Store/Account Name",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("Account Type")) {
							const value = row["Account Type"];
							if (value) {
								if (!accountTypes.some(type => value == type)) {
									this.addError({
										row: rowIndex + 2,
										column: "Account Type",
										details: `value should be one of ${accountTypes}`
									});
								}
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Account Type",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("Store Type")) {
							const value = row["Store Type"];
							const accountType = row["Account Type"];
							if (value && accountType != "store") {
								this.addError({
									row: rowIndex + 2,
									column: "Store Type",
									details: `value is allowed only when Account Type is store`
								});
							}
							if (!value && accountType == "store") {
								this.addError({
									row: rowIndex + 2,
									column: "Store Type",
									details: `value is mandatory when Account Type is store`
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Store Type",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("Email")) {
							const value = row["Email"];
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "Email",
									details: `value is mandatory`
								});
							}
							if (!this.validateEmail(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Email",
									details: `Email format is wrong`
								});
							}
						}

						if (row.hasOwnProperty("Designation")) {
							const value = row["Designation"];
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "Designation",
									details: `value is mandatory`
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Designation",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("First Name")) {
							const value = row["First Name"];
							if (!value) {
								this.addError({
									row: rowIndex + 2,
									column: "First Name",
									details: `value is mandatory`
								});
							}
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "First Name",
									details: `value should be a string`
								});
							}
						}

						if (row.hasOwnProperty("Last Name")) {
							const value = row["Last Name"];
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Last Name",
									details: `value should be a string`
								});
							}
						}
						if (row.hasOwnProperty("Address")) {
							const value = row["Address"];
							if (value && !this.checkForString(value)) {
								this.addError({
									row: rowIndex + 2,
									column: "Address",
									details: `value should be a string`
								});
							}
						}
						if (row.hasOwnProperty("Latitude")) {
							const value = row["Latitude"];
							if (value && !this.checkForNumber(value) && value >= 0) {
								this.addError({
									row: rowIndex + 2,
									column: "Latitude",
									details: `value incorrect`
								});
							}
						}
						if (row.hasOwnProperty("Longitude")) {
							const value = row["Longitude"];
							if (value && !this.checkForNumber(value) && value >= 0) {
								this.addError({
									row: rowIndex + 2,
									column: "Longitude",
									details: `value incorrect`
								});
							}
						}
					});
				}
			}
		}
	}
};

const accountTypes = [
	"store",
	"warehouse",
	"central_kitchen",
	"head_office",
	"regional_office",
	"vendor"
];

const rm = {};
